import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { from, of, switchMap } from 'rxjs';

import { UserService } from '../../user/services/user.service';

export const onlineRestrictionGuard: CanActivateFn = () => {
    const userService: UserService = inject(UserService);
    const navController: NavController = inject(NavController);

    return from(userService.checkSuspension('online', true)).pipe(
        switchMap((suspension) => {
            if (suspension.suspended) {
                navController.navigateRoot('online-games');

                // Prevent the access
                return of(false);
            }

            // Allow the access
            return of(true);
        })
    );
};
